import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';

export const templateInlineTagForm = document.createElement('template');

templateInlineTagForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-button id="addTagButton" type="quiet" color="secondary" buttonHeight="small" buttonFontSize="medium" lowercase><span class="ds-icon-add"></span><span id="addTagButtonText"></span></gz-button>
    <gz-list-item noSpaceEscape isCompact id="tagNameListItem" class='hidden'></gz-list-item>
  </div>
`;
